module.exports = __webpack_public_path__ + "static/media/12UNCTAD4.1e30f1de.jpg";